//Load thu vien
import 'babel-polyfill';
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueLodash from 'vue-lodash';
import Toasted from 'vue-toasted';
import AccountKit from 'vue-facebook-account-kit'
import facebookLogin from 'facebook-login-vuejs';
import VueScrollTo from 'vue-scrollto';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueTheMask from 'vue-the-mask';
import Datepicker from 'vuejs-datepicker';

//Bien global
const isDev = false;
//Dev config
const devURI = 'http://localhost/snap'; // Cái này anh khai báo thêm nếu trên livesite khác thì cũng cần đổi
if(isDev) {
  Vue.prototype.$foodbookConfig =  {
    domain: "www.snap.com.vn",
    api: "https://api.foodbook.vn/ipos/ws/",
    pos_name: "NHSNAP",
    pos_id: 5904,
    wpapi: devURI + "/wp-json/wz-foodbook/v1",
    imageDefault:devURI + "/wp-content/plugins/wz-foodbook/assets/images/default.png",
    logo:devURI + "/wp-content/plugins/wz-foodbook/assets/images/logo.png",
    googleMapApi:"AIzaSyAUY-T_NsSduIoG2I5ER_q9FScsd7IAs5A",
    ajaxurl: devURI + "/wp-admin/admin-ajax.php",
    time_range: 30, //Khoảng thời gian giao hàng
    timeLimit: 3, //Chỉ giao trong khoang thoi gian x ngay
    fbAppId:"368967123860590",
    hotline: "1900 8080",
    homepage : '#',
    menupage : '#',
    checkoutpage : '#',
    orderpage : '#',
    loginpage : '#',
    profilepage: '#',
    customerpage: '#',
    user_phone:"84586391141",
    userId:10
  };
} else {
  //Global variables
  Vue.prototype.$foodbookConfig =  {
    domain: "thaistreet.com.vn",
    api: wzFoodbookData.foodbookapi || "https://api.foodbook.vn/ipos/ws/",
    pos_name: wzFoodbookData.pos_name || "SAOBANG",
    pos_id: wzFoodbookData.pos_id || 0,
    wpapi: wzFoodbookData.restapi || null,
    imageDefault: wzFoodbookData.imageDefault || null,
    logo: wzFoodbookData.logo || null,
    googleMapApi: wzFoodbookData.maps_api || null,
    time_range: 30, //Khoảng thời gian giao hàng
    timeLimit: 3, //Chỉ giao trong khoang thoi gian x ngay
    fbAppId: wzFoodbookData.facebookapi,
    hotline: wzFoodbookData.hotline,
    homepage : wzFoodbookData.homepage,
    menupage : wzFoodbookData.menupage,
    checkoutpage : wzFoodbookData.checkoutpage,
    orderpage : wzFoodbookData.orderpage,
    loginpage : wzFoodbookData.loginpage,
    profilepage: wzFoodbookData.profilepage,
    customerpage: wzFoodbookData.customerpage,
    user_phone: wzFoodbookData.user_phone || 0,
    userId: wzFoodbookData.userId || 0,
  };
}


//Su dung cac thu vien
Vue.use(VueResource);
Vue.use(Toasted);
Vue.use(AccountKit);
Vue.use(VueScrollTo);
Vue.use(VueTheMask);
Vue.use(VueLodash, {
  name: 'lodash'
});
Vue.use(VueGoogleMaps, {
  load: {
    key: Vue.prototype.$foodbookConfig.googleMapApi,
    libraries: 'places',
  },
});

import './assets/css/font-awesome.min.css';
// import './assets/css/main.css';


//Config
Vue.config.productionTip = false;


if(sessionStorage.cart){
  Vue.prototype.$cart = JSON.parse(sessionStorage.cart)
}else{
  Vue.prototype.$cart = {
    coupon_log_id: '',
    user_id: null,
    username: null,
    note: null,
    longitude: null,
    latitude: null,
    to_address: null,
    province: null,
    district: null,
    ship_price_real: 0,
    distance: null,
    amount: null,
    total_amount: null,
    PaymentInfo: {
      Payment_Method: "PAYMENT_ON_DELIVERY",
      Payment_Info: "1",
      Amount: 0
    },
    ordersItem:[]
  };
}
if(sessionStorage.mapCenter){
  Vue.prototype.$mapCenter = JSON.parse(sessionStorage.mapCenter)
}else{
  Vue.prototype.$mapCenter = {
    Pos_Longitude: 0,
    Pos_Latitude:0
  };
}

//Load component
import Login from './components/Login';
import Menu from './components/Menu';
import ModalProduct from './components/ModalProduct';
import Checkout from './components/Checkout';
import Order from './components/Order';
import Header from './components/Header';
import Profile from './components/Profile';
import UpdateProfile from './components/UpdateProfile';
import SetAddress from './components/SetAddress';

//Global component
Vue.component('login-facebook',facebookLogin);
Vue.component('modal-product',ModalProduct);
Vue.component('google-map', VueGoogleMaps.Map);
Vue.component('google-marker', VueGoogleMaps.Marker);
Vue.component('datepicker', Datepicker);

//Global filter
Vue.filter('formatPrice', function (value) {
  let val = (value / 1).toFixed(0).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' vnđ';
});
Vue.filter('totalPrice', function (cart) {
  if(cart && cart.ordersItem.length){
    let total = 0;
    for(let i=0 ;i<cart.ordersItem.length;i++){
      let item = cart.ordersItem[i];
      total +=  (item.order.Price + item.order.plusPrice) * item.order.Quantity;
    }

    let val = (total / 1).toFixed(0).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' vnđ';
  }
  return '0 vnđ';
});
Vue.filter('totalPriceCart', function (cart) {
  let total = 0;
  if(cart && cart.ordersItem.length){
    for(let i=0 ;i<cart.ordersItem.length;i++){
      let item = cart.ordersItem[i];
      total +=  (item.order.Price + item.order.plusPrice) * item.order.Quantity;
    }
  }

  if(cart.ship_price_real && cart.ship_price_real > 0){
    total += cart.ship_price_real
  }

  if(cart.Discount_Amount){
    total -= cart.Discount_Amount
  }


  let val = (total / 1).toFixed(0).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' vnđ';
});
Vue.filter('totalPriceWidthVAT', function (cart, isFormat = false) {
  if(cart && cart.ordersItem.length){
    let total = 0;
    for(let i=0 ;i<cart.ordersItem.length;i++){
      let item = cart.ordersItem[i];
      total +=  (item.order.Price + item.order.plusPrice) * item.order.Quantity;
    }
    total = total * 1.08

    if(cart.ship_price_real && cart.ship_price_real > 0){
      total += cart.ship_price_real
    }
    if(cart.Discount_Amount){
      total -= cart.Discount_Amount
    }
    if (total > 0) {
      if (isFormat) {
        let val = (total / 1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' vnđ';
      } else {
        return total;
      }
    }
  }
  return 0;
});
Vue.filter('totalPriceNotFormat', function (cart) {
  const vat = 0.08
  if(cart && cart.ordersItem.length){
    let total = 0;
    for(let i=0 ;i<cart.ordersItem.length;i++){
      let item = cart.ordersItem[i];
      total +=  (item.order.Price + item.order.plusPrice) * item.order.Quantity;
    }
    return total*(1 + vat);
  }
  return 0;
});
Vue.filter('countTotalItems', function (cart) {
  if(cart && cart.ordersItem.length){
    let total = 0;
    for(let i=0 ;i<cart.ordersItem.length;i++){
      let item = cart.ordersItem[i];
      total += item.order.Quantity;
    }
    return total;
  }
  return 0;
});

Vue.filter('renderOrderItems', function (cart) {
  let items = [];
  if(cart && cart.ordersItem.length){
    for(let i=0 ;i<cart.ordersItem.length;i++){
      let item = cart.ordersItem[i].order;
      let product_data = cart.ordersItem[i].product;
      let notes = [];

      if(item.options) {
        if (item.isCombo) {
          _.forEach(item.options, (val, key) => {
            _.forEach(val.details, (detail, index) => {
              if (detail.Item_Id === val.selected) {
                let productInCombo = {
                  "Item_Type_Id": detail.Item_Type_Id,
                  "Item_Id": detail.Item_Id,
                  "Item_Name": detail.Item_Name,
                  "Price": 0,//val.ta_price,
                  "Amount": 0,//val.ta_price,
                  "Quantity": 1,
                  "Note": "",
                  "mDiscount": 0,
                  "fix": 1,
                  "Package_Id": item.Package_Id
                };
                items.push(productInCombo);
              }
            });
          });
        } else {
          _.forEach(item.options, (val, key) => {
            if (val.options.length) {
              let noteText = val.name + ': ' + _.join(val.options, ', ');
              notes.push(noteText);
            }
          })
        }

      } // item.options

      if(item.Note){
        notes.push(item.Note);
      }

      let product = {};
      let option_products = [];

      if (item.isCombo) {
        product = {
          "Item_Type_Id": item.Item_Type_Id,
          "Item_Id": item.Item_Id,
          "Item_Name": item.Item_Name,
          "Price": item.Price,
          "Amount": (parseFloat(item.Price) + parseFloat(item.plusPrice)) * item.Quantity,
          "Quantity": item.Quantity,
          "Discount": item.Discount,
          "Package_Id": item.Package_Id
        }
      } else {
        console.log('Sản phẩm có customizations ')
        product = {
          "Item_Type_Id": item.Item_Type_Id,
          "Item_Id": item.Item_Id,
          "Item_Name": item.Item_Name,
          "Price": item.Price,
          "Amount": parseFloat(item.Price) * item.Quantity,
          "Quantity": item.Quantity,
          "Note": item.Note || "",
          "Discount": item.Discount
        }

        // tính thêm các options
        //console.log('tạo sp options',item)
        _.each(item.options, (opt, key) => {
          let {customizations,store_item_id} = product_data

          // customizations case
          if (customizations && opt.min === 1 && opt.max === 1) {
            let o = _.find(customizations[key].options, function (obj) {
              return obj.name === opt.options[0];
            });

            if (o) {
              let {store_item_id} = product_data;
              store_item_id = store_item_id != null ? store_item_id : '';

              let _opt = {
                "Item_Type_Id": "",
                "Item_Id": o.id,
                "Item_Name": o.name,
                "Price": o.ta_price,
                "Amount": parseFloat(o.ta_price) * item.Quantity,
                "Quantity": item.Quantity,
                "Note": "Option " + key,
                "Parent_Id": store_item_id,
                "parent_id": store_item_id,
                "Discount": 0
              }
              option_products.push(_opt);
            }
          } else {
            if (opt.options) {
              _.forEach(opt.options, op => {
                if (op.quantity > 0) {
                  let _op = {
                    "Item_Type_Id": "",
                    "Item_Id": op.id,
                    "Item_Name": op.name,
                    "Price": op.ta_price,
                    "Amount": parseFloat(op.ta_price) * op.quantity,
                    "Quantity": op.quantity,
                    "Note": op.Note || "",
                    "Parent_Id": store_item_id,
                    "parent_id": store_item_id,
                    "Discount": 0
                  }
                  option_products.push(_op);
                }
              });
            }
          }


        });
      }

      items.push(product);

      // thêm option (topping)
      if (option_products.length) {
        _.forEach(option_products, opt => {
          items.push(opt);
        })
      }

    } // for
  }
  return items;
});

new Vue({
  el: '#wiz-foodbook',
  components: {
    login: Login,
    'menu-items': Menu,
    checkout: Checkout,
    order: Order,
    'header-foodbook': Header,
    profile: Profile,
    'update-profile': UpdateProfile,
    'set-address':SetAddress

  },
  data() {
    return {
      search: '',
    }
  },
  methods:{
    updateSearchFnc(val){
      this.search =  val;
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js